import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'schoolYear',
})
export class SchoolYearPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return '';
        }

        return value.length === 4 ? `20${value.substring(0, 2)} - 20${value.substring(2)}` : `${value.substring(0, 4)} - ${value.substring(4)}`;
    }
}
